import React from 'react';
import { Input, InputGroup, InputGroupText } from 'reactstrap';
import { mergeClassNames } from '@core/shared';

export function TextInput({
    elementType,
    elementConfig,
    analyticsClassName,
    warningAnalyticsClassName,
    isInvalid,
    isValid,
    isWarning,
    value,
    sharedLabelAttr,
    onChange,
    autoComplete,
    inlineIcon,
    required,
}) {
    const warningActive = isWarning;
    const warningInputClass = warningActive
        ? mergeClassNames('border-warning', 'is-warning', 'focus-ring', warningAnalyticsClassName)
        : '';
    const warningInputStyle = warningActive
        ? {
              '--bs-focus-ring-color': 'rgba(var(--bs-warning-rgb), .25)',
              '--bs-form-control-focus-border-color': 'var(--bs-warning)',
          }
        : undefined;

    const mergedClassName = mergeClassNames(elementConfig?.className, warningInputClass);
    const mergedStyle = elementConfig?.style ? { ...elementConfig.style, ...warningInputStyle } : warningInputStyle;

    let validationStateClass = '';
    if (warningActive) {
        validationStateClass = 'is-warning';
    } else if (isInvalid) {
        validationStateClass = 'is-invalid';
    } else if (isValid) {
        validationStateClass = 'is-valid';
    }

    let coreInput;
    if (elementType === 'textarea') {
        coreInput = (
            <Input
                type="textarea"
                placeholder={elementConfig.placeholder}
                className={mergeClassNames(mergedClassName, analyticsClassName)}
                style={mergedStyle}
                invalid={isInvalid}
                {...sharedLabelAttr}
                value={value}
                onChange={onChange}
                rows="8"
                required={required}
                aria-required={required}
            />
        );
    } else {
        coreInput = (
            <Input
                {...elementConfig}
                className={mergeClassNames(mergedClassName, analyticsClassName)}
                style={mergedStyle}
                invalid={elementType === 'input' ? isInvalid : undefined}
                value={value}
                {...sharedLabelAttr}
                onChange={onChange}
                autoComplete={elementConfig.autoComplete || autoComplete || 'off'}
                valid={elementType === 'input' ? isValid : undefined}
                required={required}
                aria-required={required}
            />
        );
    }

    if (inlineIcon) {
        return (
            <InputGroup>
                <InputGroupText className={validationStateClass}>
                    {inlineIcon && React.createElement(inlineIcon, { size: 20 })}
                </InputGroupText>
                {coreInput}
            </InputGroup>
        );
    }

    return coreInput;
}
